module.exports = ".action-button {\n  background-color: #fecc00;\n  color: #000;\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  padding: 7px 30px;\n  margin-left: 2px;\n  margin-right: 2px;\n}\n\n.color-red {\n  color: red !important;\n}\n\n::ng-deep .numberformat {\n  text-align: right;\n}\n\nli {\n  list-style: none;\n}\n\n.data {\n  text-align: right !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/budget/new-budget/new-budget.component.scss
// module id = ./src/app/system/budget/new-budget/new-budget.component.scss
// module chunks = main